import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'
import theme from '../../constants/theme'
import { ConsentRow, ErrorText } from './styled'

const Req = () => <span style={{ color: theme.danger }}> *</span>

function ConsentField() {
  const { t } = useTranslation()
  const { control } = useFormContext()
  return (
    <Controller
      name="consent"
      control={control}
      render={({ field, fieldState }) => (
        <>
          <ConsentRow>
            <input
              type="checkbox"
              checked={!!field.value}
              onChange={(e) => field.onChange(e.target.checked)}
              style={{ marginTop: '3px' }}
            />
            <span>
              {t('reference.consentDetails')}
              <Req />
            </span>
          </ConsentRow>
          {fieldState.error && (
            <div style={{ marginTop: '-12px', marginBottom: '16px' }}>
              <ErrorText>{fieldState.error.message}</ErrorText>
            </div>
          )}
        </>
      )}
    />
  )
}

export default ConsentField
